import styled from 'styled-components';

const CategoryTitle = styled.span`
    font-weight: ${({ theme }) => theme.site.categoryTitle.fontWeight};
    text-transform: ${({ theme }) =>
        theme.site.categoryTitle.uppercase ? 'uppercase' : 'capitalize'};
`;

export default CategoryTitle;
